// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================
   Markdown 코드 블록 (MarkdownCodeBlock)
   피그마 2026-05 시안 — 채팅/마크다운 본문 공통
   ===================================================== */
.md-codeblock {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 12px 0;
  border-radius: 12px;
  overflow: hidden;
  background: #383838;
  border: 0;
}

/* 헤더 */
.md-codeblock__head {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 56px;
  padding: 12px 20px;
  background: #4e5169;
  color: #fff;
}

.md-codeblock__lang {
  flex: 1 0;
  min-width: 0;
  margin: 0;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.md-codeblock__actions {
  display: flex;
  align-items: center;
  gap: 0;
}

.md-codeblock__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 2px;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}

.md-codeblock__icon-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
}

.md-codeblock__icon-btn:active:not(:disabled) {
  background: rgba(255, 255, 255, 0.18);
}

.md-codeblock__icon-btn:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.6);
  outline-offset: -2px;
}

/* 본문 — 마크다운 래퍼별 specificity 처리 */
.llm-chat__markdown .md-codeblock__body,
.agent-share__markdown .md-codeblock__body,
.skill-modal__markdown .md-codeblock__body,
pre.md-codeblock__body {
  margin: 0;
  padding: 20px;
  background: #383838;
  color: #fff;
  border: 0;
  border-radius: 0;
  font-family: 'JetBrains Mono', ui-monospace, 'SF Mono', Consolas, Menlo, monospace;
  font-size: 15px;
  line-height: 28px;
  overflow-x: auto;
  white-space: pre;
  tab-size: 2;
}

.llm-chat__markdown .md-codeblock__body code,
.agent-share__markdown .md-codeblock__body code,
.skill-modal__markdown .md-codeblock__body code,
.md-codeblock__body > code {
  display: block;
  padding: 0;
  background: transparent;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border-radius: 0;
  white-space: inherit;
}

/* 스크롤바 */
.md-codeblock__body::-webkit-scrollbar {
  height: 8px;
}
.md-codeblock__body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 4px;
}
.md-codeblock__body::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.28);
}
.md-codeblock__body::-webkit-scrollbar-track {
  background: transparent;
}

`, "",{"version":3,"sources":["webpack://./src/css/CodeBlock.css"],"names":[],"mappings":"AAAA;;;0DAG0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA,OAAO;AACP;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC;;;;EAIE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,kFAAkF;EAClF,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;EAIE,cAAc;EACd,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,WAAW;AACb;AACA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,uBAAuB;AACzB","sourcesContent":["/* =====================================================\n   Markdown 코드 블록 (MarkdownCodeBlock)\n   피그마 2026-05 시안 — 채팅/마크다운 본문 공통\n   ===================================================== */\n.md-codeblock {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin: 12px 0;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #383838;\n  border: 0;\n}\n\n/* 헤더 */\n.md-codeblock__head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 56px;\n  padding: 12px 20px;\n  background: #4e5169;\n  color: #fff;\n}\n\n.md-codeblock__lang {\n  flex: 1 0 0;\n  min-width: 0;\n  margin: 0;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 28px;\n  color: #fff;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.md-codeblock__actions {\n  display: flex;\n  align-items: center;\n  gap: 0;\n}\n\n.md-codeblock__icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 2px;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 120ms ease, color 120ms ease;\n}\n\n.md-codeblock__icon-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.md-codeblock__icon-btn:active:not(:disabled) {\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.md-codeblock__icon-btn:focus-visible {\n  outline: 2px solid rgba(255, 255, 255, 0.6);\n  outline-offset: -2px;\n}\n\n/* 본문 — 마크다운 래퍼별 specificity 처리 */\n.llm-chat__markdown .md-codeblock__body,\n.agent-share__markdown .md-codeblock__body,\n.skill-modal__markdown .md-codeblock__body,\npre.md-codeblock__body {\n  margin: 0;\n  padding: 20px;\n  background: #383838;\n  color: #fff;\n  border: 0;\n  border-radius: 0;\n  font-family: 'JetBrains Mono', ui-monospace, 'SF Mono', Consolas, Menlo, monospace;\n  font-size: 15px;\n  line-height: 28px;\n  overflow-x: auto;\n  white-space: pre;\n  tab-size: 2;\n}\n\n.llm-chat__markdown .md-codeblock__body code,\n.agent-share__markdown .md-codeblock__body code,\n.skill-modal__markdown .md-codeblock__body code,\n.md-codeblock__body > code {\n  display: block;\n  padding: 0;\n  background: transparent;\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  border-radius: 0;\n  white-space: inherit;\n}\n\n/* 스크롤바 */\n.md-codeblock__body::-webkit-scrollbar {\n  height: 8px;\n}\n.md-codeblock__body::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.18);\n  border-radius: 4px;\n}\n.md-codeblock__body::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.28);\n}\n.md-codeblock__body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
